import { Component, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from '../../../shared/services/auth.service';

@Component({
	selector: 'app-recupera-password-web',
	standalone: true,
	imports: [CommonModule, FormsModule],
	templateUrl: './recupera-password.component.html',
})
export class RecuperaPasswordWebComponent {
	private router = inject(Router);
	private authService = inject(AuthService);

	username = signal('');
	loading = signal(false);
	success = signal(false);
	error = signal(false);
	errorMessage = signal('');

	resetPassword() {
		if (!this.username()) return;
		this.loading.set(true);
		this.success.set(false);
		this.error.set(false);
		this.errorMessage.set('');

		this.authService.resetPassword(this.username()).subscribe({
			next: () => {
				this.loading.set(false);
				this.success.set(true);
			},
			error: (err) => {
				this.loading.set(false);
				this.error.set(true);
				this.errorMessage.set(err.error || 'Utente non valido');
			},
		});
	}

	goToLogin() {
		this.router.navigate(['/web/public/login']);
	}
}
